var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { BrandClientService } from "../../../../../services/modules/brand-client.service";
import { LotteryPlatformClaims } from '../../../../../constants/modules/lotteryplatform.claims';
import { UserClaimsService } from '../../../../../services/authentication/user-claims.service';
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { OperatorClientService } from "../../../../../services/modules/operator-client.service";
import { computedFrom } from "aurelia-binding";
import * as Enumerable from "linq";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
var OperatorBasicMeta = /** @class */ (function (_super) {
    __extends(OperatorBasicMeta, _super);
    function OperatorBasicMeta(notificationService, i18N, tokenClientService, userClaimsService, queriesClientService, brandClientService, operatorClientService, dialogClient) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.tokenClientService = tokenClientService;
        _this.userClaimsService = userClaimsService;
        _this.queriesClientService = queriesClientService;
        _this.brandClientService = brandClientService;
        _this.operatorClientService = operatorClientService;
        _this.dialogClient = dialogClient;
        _this.viewOperatorCredit = _this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewOperatorCredit);
        _this.editOperatorCredit = _this.userClaimsService.hasPermission(LotteryPlatformClaims.EditOperatorCredit);
        return _this;
    }
    Object.defineProperty(OperatorBasicMeta.prototype, "isOperatorMarginPercentagePlatformAndInsurance", {
        get: function () {
            return this.item.isOperatorMarginPercentagePlatformAndInsurance;
        },
        set: function (value) {
            this.item.isOperatorMarginPercentagePlatformAndInsurance = value;
            if (value) {
                this.isFixedOperator = false;
                this.item.isOperatorMarginPercentage = false;
                this.item.isOperatorMarginPercentageGross = false;
            }
        },
        enumerable: false,
        configurable: true
    });
    OperatorBasicMeta.prototype.topup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.operatorClientService.topup(this.item.operatorId, this.topUpAmount)];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.loadOperatorCredit()];
                    case 2:
                        _b.sent();
                        this.topUpAmount = null;
                        this.notificationService.show("Top-up", "Top-up successful", NotificationType.Success);
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        this.notificationService.show("Top-up", "Top-up failed", NotificationType.Error);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(OperatorBasicMeta.prototype, "isAdmin", {
        get: function () {
            return this.tokenClientService.isSuperAdmin();
        },
        enumerable: false,
        configurable: true
    });
    OperatorBasicMeta.prototype.loadOperatorCredit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queriesClientService.getData("odata/OperatorCredits?$filter=operatorId eq ".concat(this.item.operatorId))];
                    case 1:
                        response = _a.sent();
                        this.creditModel = response.value[0];
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(OperatorBasicMeta.prototype, "isFixed", {
        get: function () {
            return !this.item.isPlatformMarginPercentage && !this.item.isPlatformMarginPercentageGross;
        },
        set: function (checked) {
            if (!checked)
                return;
            this.item.isPlatformMarginPercentage = false;
            this.item.isPlatformMarginPercentageGross = false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OperatorBasicMeta.prototype, "isFixedOperator", {
        get: function () {
            return !this.item.isOperatorMarginPercentage && !this.item.isOperatorMarginPercentageGross && !this.item.isOperatorMarginPercentagePlatformAndInsurance;
        },
        set: function (checked) {
            if (!checked)
                return;
            this.item.isOperatorMarginPercentage = false;
            this.item.isOperatorMarginPercentageGross = false;
            this.item.isOperatorMarginPercentagePlatformAndInsurance = false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OperatorBasicMeta.prototype, "isFixedInstantGames", {
        get: function () {
            return !this.item.isInstantGamesPlatformMarginPercentage && !this.item.isInstantGamesPlatformMarginPercentageGross;
        },
        set: function (checked) {
            if (!checked)
                return;
            this.item.isInstantGamesPlatformMarginPercentage = false;
            this.item.isInstantGamesPlatformMarginPercentageGross = false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OperatorBasicMeta.prototype, "isFixedOperatorInstantGames", {
        get: function () {
            return !this.item.isInstantGamesOperatorMarginPercentage && !this.item.isInstantGamesOperatorMarginPercentageGross;
        },
        set: function (checked) {
            if (!checked)
                return;
            this.item.isInstantGamesOperatorMarginPercentage = false;
            this.item.isInstantGamesOperatorMarginPercentageGross = false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OperatorBasicMeta.prototype, "isFixedSweepstakes", {
        get: function () {
            return !this.item.isSweepstakesPlatformMarginPercentage && !this.item.isSweepstakesPlatformMarginPercentageGross;
        },
        set: function (checked) {
            if (!checked)
                return;
            this.item.isSweepstakesPlatformMarginPercentage = false;
            this.item.isSweepstakesPlatformMarginPercentageGross = false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OperatorBasicMeta.prototype, "isFixedOperatorSweepstakes", {
        get: function () {
            return !this.item.isSweepstakesOperatorMarginPercentage && !this.item.isSweepstakesOperatorMarginPercentageGross;
        },
        set: function (checked) {
            if (!checked)
                return;
            this.item.isSweepstakesOperatorMarginPercentage = false;
            this.item.isSweepstakesOperatorMarginPercentageGross = false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OperatorBasicMeta.prototype, "isBrandAdmin", {
        get: function () {
            return this.tokenClientService && this.tokenClientService.isBrandAdmin();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OperatorBasicMeta.prototype, "isReadonly", {
        get: function () {
            return this.tokenClientService && this.tokenClientService.isBrandAdmin();
        },
        enumerable: false,
        configurable: true
    });
    OperatorBasicMeta.prototype.addUser = function () {
        this.item.operatorUsers.push(this.defaultUser);
    };
    OperatorBasicMeta.prototype.onSelectControlChanged = function (index) {
        if (Enumerable.from(this.item.operatorUsers).where(function (x) { return x.userId != 0; }).groupBy(function (x) { return x.userId; }).any(function (c) { return c.count() > 1; })) {
            this.notificationService.show("Validation Error!", "This user is already assigned to this operator.", NotificationType.Error);
            if (this.item.operatorUsers.length != 0) {
                this.item.operatorUsers[index].userId = 0;
            }
        }
    };
    OperatorBasicMeta.prototype.removeUser = function (userItem) {
        var _this = this;
        require("../../dialogs/delete-modal"); // this is to show delete modal dialog
        this.dialogClient.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
            delete: function () { return new Promise(function (resolve, reject) {
                resolve();
                var index = _this.item.operatorUsers.indexOf(userItem);
                _this.item.operatorUsers.splice(index, 1);
                _this.dialogClient.hide();
            }); }
        });
    };
    OperatorBasicMeta.prototype.onActivated = function (item) {
        this.loadStats(false);
        this.cannotSeeCosts = !this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorShowCostsOfOperatorMargins)
            && !this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorShowCostsOfPlatformMargins);
        this.showPlatformMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorShowCostsOfPlatformMargins);
        this.showOperatorMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.OperatorShowCostsOfOperatorMargins);
        this.cannotSeeInstantGamesCosts = !this.userClaimsService.hasPermission(LotteryPlatformClaims.InstantGamesOperatorShowCostsOfOperatorMargins)
            && !this.userClaimsService.hasPermission(LotteryPlatformClaims.InstantGamesOperatorShowCostsOfPlatformMargins);
        this.showInstantGamesPlatformMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.InstantGamesOperatorShowCostsOfPlatformMargins);
        this.showInstantGamesOperatorMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.InstantGamesOperatorShowCostsOfOperatorMargins);
        this.cannotSeeBundlesCosts = !this.userClaimsService.hasPermission(LotteryPlatformClaims.BundlesOperatorShowCostsOfOperatorMargins)
            && !this.userClaimsService.hasPermission(LotteryPlatformClaims.BundlesOperatorShowCostsOfPlatformMargins);
        this.showBundlesPlatformMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.BundlesOperatorShowCostsOfPlatformMargins);
        this.showBundlesOperatorMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.BundlesOperatorShowCostsOfOperatorMargins);
        this.cannotSeeSyndicatesCosts = !this.userClaimsService.hasPermission(LotteryPlatformClaims.SyndicatesOperatorShowCostsOfOperatorMargins)
            && !this.userClaimsService.hasPermission(LotteryPlatformClaims.SyndicatesOperatorShowCostsOfPlatformMargins);
        this.showSyndicatesPlatformMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.SyndicatesOperatorShowCostsOfPlatformMargins);
        this.showSyndicatesOperatorMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.SyndicatesOperatorShowCostsOfOperatorMargins);
        this.cannotSeeSweepstaksCosts = !this.userClaimsService.hasPermission(LotteryPlatformClaims.SweepstakesOperatorShowCostsOfPlatformMargins)
            && !this.userClaimsService.hasPermission(LotteryPlatformClaims.SweepstakesOperatorShowCostsOfOperatorMargins);
        this.showSweepstakesPlatformMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.SweepstakesOperatorShowCostsOfPlatformMargins);
        this.showSweepstakesOperatorMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.SweepstakesOperatorShowCostsOfOperatorMargins);
        this.loadOperatorCredit();
    };
    OperatorBasicMeta.prototype.loadStats = function (showAll) {
        var _this = this;
        this.showAll = showAll;
        this.brandClientService.getBrandOrOperatorStats(null, this.item.operatorId, showAll).then(function (x) { return _this.brandStats = x; })
            .catch(function (e) { return _this.notificationService.show(_this.i18N.tr('error-text') + "!", "Error loading stats for Operator", NotificationType.Error); });
    };
    Object.defineProperty(OperatorBasicMeta.prototype, "defaultUser", {
        get: function () {
            return {
                userId: 0,
                branchId: 0,
                departmentId: 0,
                roleId: 0
            };
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        computedFrom("item.isOperatorMarginPercentagePlatformAndInsurance"),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], OperatorBasicMeta.prototype, "isOperatorMarginPercentagePlatformAndInsurance", null);
    OperatorBasicMeta = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N, TokenClient,
            UserClaimsService, QueriesClientService,
            BrandClientService, OperatorClientService,
            DialogClientService])
    ], OperatorBasicMeta);
    return OperatorBasicMeta;
}(ChildComponent));
export { OperatorBasicMeta };
